import React from 'react';

function AuthShell({ children, aside }) {
  return (
    <div className="nurturer-auth">
      <main className="auth">
        <section className="auth-form">{children}</section>
        {aside}
      </main>
    </div>
  );
}

export default AuthShell;
